import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimResponseScreen } from 'screens/claim';

export default withPermissions(ClaimResponseScreen, [
  GroupSecurity.ClaimResponseRead,
]);
